/**
 * Configuración automática de URLs para Preview y Producción
 * 
 * Si REACT_APP_BACKEND_URL está vacío, usa el origen actual (window.location.origin)
 * Esto hace que funcione automáticamente en Preview y Producción
 */

const getBackendURL = () => {
  // Si hay una URL específica configurada, usarla
  if (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL.trim() !== '') {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Si no, usar el mismo dominio donde está alojado el frontend
  // Esto funciona automáticamente en Preview y Producción
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Fallback para SSR
  return '';
};

export const BACKEND_URL = getBackendURL();
export const API_URL = BACKEND_URL + '/api';

export default {
  BACKEND_URL,
  API_URL
};
